import React from "react";
import { ArrowRight } from "lucide-react";
import { useSiteContent } from "../../hooks/useSiteContent";

export default function CTAButton({ centered = false, className = "", text }) {
  const { content } = useSiteContent();
  const label = text || content.cta_button_text || "Agendar consultoria";
  return (
    <div className={`${centered ? "text-center" : "text-left"} ${className} mt-12`}>
      <a
        href="#contato"
        className="inline-flex items-center gap-2 px-8 py-4 rounded-full text-primary-foreground font-medium shadow-gold transition-all hover:translate-y-[-1px]"
        style={{ background: "var(--gold-gradient)" }}
      >
        {label} <ArrowRight size={16} />
      </a>
    </div>
  );
}
